/* Handing the game's address to somebody.

   `navigator.share` opens the device's own share sheet — WhatsApp, Instagram messages, Telegram,
   mail, whatever the phone has installed — and it is the only door to those apps a page has:
   there is no URL scheme for "send an Instagram message", and a row of hand-drawn network buttons
   would be a fixed guess at what the player uses, wrong on every phone with a different app.
   Where there is no sheet (most desktop browsers) the address goes to the clipboard instead,
   and the caller says so, because a button that silently did that reads as a button that did
   nothing.

   Four answers, so the caller can word each: SHARED (the sheet closed on a pick — the phone's
   own app takes it from there, so nothing is said), COPIED (the clipboard has it), CANCELLED
   (the sheet was closed on nothing, which is not something to report) and FAILED (neither
   worked, so the address itself is what to show). */

export const SHARED = "shared"
export const COPIED = "copied"
export const CANCELLED = "cancelled"
export const FAILED = "failed"

/** Whether this browser has a share sheet, so a button can say "share" or "copy" ahead of time. */
export const canShare = () => typeof navigator !== "undefined" && typeof navigator.share === "function"

export const shareLink = async ({ url, title, text }) => {
  if (canShare()) {
    try {
      await navigator.share({ url, title, text })
      return SHARED
    } catch (error) {
      if (error?.name === "AbortError") return CANCELLED
      // A sheet already open, or a browser that has the function but refuses the payload: the
      // clipboard below is the next best thing, not an error to show.
    }
  }
  try {
    await navigator.clipboard.writeText(url)
    return COPIED
  } catch (error) {
    return FAILED
  }
}
